import React, { Suspense, useCallback, useContext, useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { TostMsg } from "../../../App";
import {
  getTicketListData,
  addTicket,
  addObserver,
  deleteTicketObserverListData,
  addTicketAttachmentData,
  deleteTicketAttachmentData,
} from "../TicketManagement/TicketService";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getEmployeeList } from "../EmployeeList/Service/employeeService";
import {
  GetMasterTypeData,
  uploadDoc,
} from "../../../Services/Global-Services/GlobalServices";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { AutoComplete } from "primereact/autocomplete";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import { PostDate } from "../Dashboard/CommonComponents/PostDate";
import moment from "moment";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import UploadFile_KEYS from "../../../Services/Global-Services/UploadFile_Keys";
const ComponentLoader = React.lazy(() =>
  import("../../../Shared/Sidebar/ComponentLoader")
);
const defaultImage = "/images/placeholder_profile.png";
function AssetsDetailHtml() {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const { RequestNumber } = useParams();
  const [ticketDetailsData, setTicketDetailsData] = useState([]);
  const [ticketHistoryDetailsData, setTicketHistoryDetailsData] = useState([]);
  const [showFirstDetailsOfHistory, setShowFirstDetailsOfHistory] = useState(
    []
  );
  const [tickeObservertDetailsData, setTicketObserverDetailsData] = useState(
    []
  );
  const toster = useContext(TostMsg);
  const [Isloading, setIsloading] = useState(false);
  const [selectedEmployees, setSelectedEmployees] = useState(null);
  const [employeDetails, setEmployeeDetails] = useState([]);
  const [observers, setObservers] = useState([]);
  const [selectedObservers, setSelectedObservers] = useState(null);
  const [filteredObservers, setFilteredObservers] = useState(null);
  const [showAllDocvisible, setShowAllDocvisible] = useState(false);
  const [showAllDelete, setShowAllDelete] = useState({
    show: false,
    type: "",
  });
  const [deleteTicketItemId, setDeleteTicketItemId] = useState(0);
  const [ticketMasterDataList, setTicketMasterDataList] = useState([]);
  const [deleteContent, setDeleteContent] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [selectedServerity, setSelectedServerity] = useState(null);
  const [selectedPriority, setSelectedPriority] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [description, setDescription] = useState("");
  const [RequestTitle, setRequestTitle] = useState("");
  const [ticketNotificationId, setTicketNotificationId] = useState(0);
  const [ticketStatusType, setTicketStatusType] = useState([]);
  const [ticketCategoryType, setTicketCategoryType] = useState([]);
  const [ticketSubcategoryType, setTicketSubcategoryType] = useState([]);
  const [ticketSubcategoryTypeSelected, setTicketSubcategoryTypeSelected] =
    useState([]);
  const [ticketPriorityType, setTicketPriorityType] = useState([]);
  const [ticketSeverityType, setTicketSeverityType] = useState([]);
  const history = useHistory();
  let ticketId;
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");

  const panelFooterTemplate = () => {
    const isObserversSelected = (filteredObservers || []).some(
      (country) => country["FullName"] === selectedObservers
    );
    return (
      <div className="py-2 px-3">
        {isObserversSelected ? (
          <span>
            <b>{selectedObservers}</b> selected.
          </span>
        ) : (
          "No Observers selected."
        )}
      </div>
    );
  };

  useEffect(() => {
    getMasterTicketStatus();
    getMasterTicketCategory();
    getMasterTicketSubCategory();
    getMasterTicketPriority();
    getMasterTicketSeverity();
    fetchEmployeeIdData();
    if (RequestNumber?.length <= 4) {
      setTicketNotificationId(Number(RequestNumber));
    } else {
      getTicketData();
    }
  }, []);

  async function getTicketData() {
    let ticketNo;
    if (ticketNotificationId) {
      ticketNo = "";
    }
    setIsloading(true);
    const param = {
      OrgId: userDetails?.OrgId,
      LoggedInEmpId: userDetails?.EmpId,
      RaisedByEmpId: "",
      AssignedToId: "",
      TicketId: ticketId ?? 0,
      RequestStatusId: "",
      RequestCategoryId: "",
      RequestSubCategoryId: "",
      PriorityId: "",
      SeverityId: "",
      Search: "",
      filterStartDate: "",
      filterEndDate: "",
      PageNumber: 1,
      PageSize: 10,
      IsDeleted: 0,
      RequestNumber: ticketNo ?? RequestNumber,
    };
    try {
      const data = await getTicketListData(param);
      let ticketDetailData = await data?.Data?.OrgEmpRequests;
      setTicketDetailsData(ticketDetailData);
      setTicketObserverDetailsData(ticketDetailData[0]?.ObserverLists);
      setTicketHistoryDetailsData(ticketDetailData[0]?.RequestHistory);
      setIsloading(false);
    } catch {
      setIsloading(false);
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  const updateTicketValidation = Yup.object().shape({
    comment: Yup.string(),
    docPath: Yup.string(),
    AssignedToId: Yup.string(),
  });

  const updateTicketForm = useFormik({
    initialValues: {
      comment: "",
      docPath: "",
      AssignedToId: "",
    },
    validationSchema: updateTicketValidation,
    onSubmit: async (data) => {
      let commentValue;
      setIsloading(true);
      const existing = ticketDetailsData[0];
      const AssignedToEmpId = selectedEmployees?.EmpId;
      updateTicketForm.setFieldValue("AssignedToId", AssignedToEmpId);
      const updatedFieldData = {
        ticketId: existing?.Id,
        RequestTitle: RequestTitle,
        RequestDescription: description,
        RequestCategoryId: selectedCategory,
        RequestSubCategoryId: selectedSubCategory,
        Severity: selectedServerity,
        Priority: selectedPriority,
        RequestStatusId: selectedStatus,
      };
      const body = {
        Id: updatedFieldData?.ticketId || 0,
        IsDeleted: 0,
        RequestNumber: RequestNumber,
        OrgId: userDetails?.OrgId,
        EmpId: existing?.EmpId, //userDetails?.EmpId,
        RequestTitle: updatedFieldData?.RequestTitle || existing?.RequestTitle,
        RequestDescription:
          updatedFieldData?.RequestDescription || existing?.RequestDescription,
        RequestCategoryId:
          updatedFieldData?.RequestCategoryId || existing?.RequestCategoryId,
        RequestSubCategoryId:
          updatedFieldData?.RequestSubCategoryId ||
          existing?.RequestSubCategoryId,
        Comment: data?.comment,
        Severity: updatedFieldData?.Severity || existing?.Severity,
        Priority: updatedFieldData?.Priority || existing?.Priority,
        AssignedToId: AssignedToEmpId,
        RequestStatusId:
          updatedFieldData?.RequestStatusId || existing?.RequestStatusId,
      };
      if (data.comment) {
        commentValue = "";
      } else {
        commentValue = "";
      }
      const hasChanged =
        body.RequestTitle !== existing?.RequestTitle ||
        body.RequestDescription !== existing?.RequestDescription ||
        body.RequestCategoryId !== existing?.RequestCategoryId ||
        body.RequestSubCategoryId !== existing?.RequestSubCategoryId ||
        body.Severity !== existing?.Severity ||
        body.Priority !== existing?.Priority ||
        body.AssignedToId !== existing?.AssignedToId ||
        body.RequestStatusId !== existing?.RequestStatusId ||
        body.Comment !== commentValue;
      if (!hasChanged) {
        setIsloading(false);
        toster.current.warn("No changes detected.");
        return;
      }
      try {
        const createGallary = await addTicket(body);
        if (createGallary) {
          GetMasterSystemAlertList("Ticket_Updated", 0);
          if (userDetails?.EmpId === existing?.AssignedToId) {
            history.push(`/Ticket`);
          }
          updateTicketForm.resetForm();
          getTicketData();
          setIsEditing(false);
        }
      } catch (error) {
        toster.current.error(ERROR_LIST.TicketUpdate);
      } finally {
        setIsloading(false);
      }
    },
  });

  //For get the employee data.
  async function fetchEmployeeIdData() {
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 10000,
      EmployeeId: 0,
      IsSuggestedOnly: 0,
    };
    setIsloading(true);
    try {
      let employeesList = await getEmployeeList(params);
      let employeeValidateList = [];
      employeeValidateList = employeesList.Data;
      setEmployeeDetails(employeeValidateList);
      setObservers(employeesList.Data);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
    }
  }

  const handleSelectionChange = (e) => {
    setSelectedEmployees(e.value);
  };

  const employeeOptionTemplate = (option) => {
    return (
      <div className="flex align-items-center gap-2 ticket-file-attach__items_detail">
        <LazyImage alt={option.FullName} src={option.ProfileImage} width="32" />
        <span>{option.FullName}</span>
      </div>
    );
  };

  const selectedAssignName = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center gap-2 ticket-file-attach__items_detail">
          <LazyImage
            alt={option.FullName}
            src={option.ProfileImage}
            width="32"
          />
          <span>{option.FullName}</span>
        </div>
      );
    }
    return <span>{props.placeholder}</span>;
  };

  const handleFileChange = async (event) => {
    const selectedFile = event.target.files[0];
    uploadPolicyDocFile(selectedFile);
  };

  async function uploadPolicyDocFile(file) {
    if (file) {
      setIsloading(true);
      const formData = new FormData();
      formData.append("files", file);
      let params = {
        UploadType: UploadFile_KEYS?.Message,
        RefId: ticketDetailsData[0]?.EmpId ?? 0,
      };
      const response = await await uploadDoc(params, formData);
      const data = await response;
      const ticketFormData = data?.Data[0];
      updateAttachement(ticketFormData);
      setIsloading(false);
    } else {
      toster.current.warn("No file selected");
      setIsloading(false);
    }
  }

  const search = (event) => {
    setTimeout(() => {
      let _filteredObervers;
      if (!event.query.trim().length) {
        _filteredObervers = [...observers];
      } else {
        _filteredObervers = observers.filter((item) => {
          return item.FullName.toLowerCase().startsWith(
            event.query.toLowerCase()
          );
        });
      }
      setFilteredObservers(_filteredObervers);
    }, 250);
  };

  const itemTemplateObservers = (item) => {
    return (
      <div className="flex align-items-center gap-2 ticket-file-attach__items_detail">
        <LazyImage alt={item.FullName} src={item.ProfileImage} width="32" />
        <span>{item.FullName}</span>
      </div>
    );
  };

  async function addObserverData() {
    if (selectedObservers == null) {
      toster.current.warn("Please select at least one observer.");
    } else {
      const params = {
        CreatedBy: ticketDetailsData[0]?.EmpId,
        OrgId: selectedObservers?.OrgId,
        RequestId: ticketDetailsData[0]?.Id,
        ObserverId: selectedObservers?.EmpId,
      };
      setIsloading(true);
      try {
        const data = await addObserver(params);
        let employeesList = await data;
        GetMasterSystemAlertList("Observers_Added", 0);
        setTimeout(() => {
          getTicketData();
          setSelectedObservers(null);
        }, 1000);
        setIsloading(false);
      } catch (error) {
        setIsloading(false);
      }
    }
  }

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  async function deleteTicketItemData() {
    if (
      deleteTicketItemId.toLocaleString().length > 0 &&
      showAllDelete.type == "Observer"
    ) {
      const body = {
        Id: deleteTicketItemId,
        ModifiedBy: ticketDetailsData[0]?.EmpId,
      };
      let ticketList = await deleteTicketObserverListData(body);
      try {
        let ticketList = await deleteTicketAttachmentData(body);
        if (ticketList) {
          getTicketData();
          setShowAllDelete(false);
          toster.current.success("Ticket  observer  deleted successfully");
          setIsloading(false);
        }
      } catch (error) {
        toster.current.error(ERROR_LIST.DefaultError);
        setIsloading(false);
      }
    } else if (
      deleteTicketItemId.toLocaleString().length > 0 &&
      showAllDelete.type == "Doc"
    ) {
      const body = {
        docPathId: deleteTicketItemId,
        loggedInEmpId: userDetails?.EmpId,
      };
      try {
        let ticketList = await deleteTicketAttachmentData(body);
        if (ticketList) {
          getTicketData();
          setShowAllDelete(false);
          toster.current.success("Ticket  document  deleted successfully");
          setIsloading(false);
        }
      } catch (error) {
        toster.current.error(ERROR_LIST.DefaultError);
        setIsloading(false);
      }
    }
  }

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message) {
        setDeleteContent(msg?.Desc);
      }
    });
  }, []);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleCloseClick = () => {
    setIsEditing(false);
  };

  const handleChangeDescription = (e) => {
    setDescription(e.target.value);
  };

  const handleChangeTitle = (e) => {
    setRequestTitle(e.target.value);
  };

  const handleChangeStatus = (e) => {
    setSelectedStatus(e.value);
  };

  async function updateAttachement(DocPath) {
    const params = {
      OrgId: userDetails?.OrgId,
      RequestId: ticketDetailsData[0]?.Id,
      RequestDetailId: 101,
      UploadedById: userDetails?.EmpId,
      DocPath: DocPath,
    };
    try {
      const data = await addTicketAttachmentData(params);
      if (data) {
        GetMasterSystemAlertList("Ticket_Attachment_Added", 0);
        getTicketData();
      }
    } catch (error) {}
  }

  useEffect(() => {
    const requestDes = ticketDetailsData[0]?.RequestDescription || "";
    const requestTitle = ticketDetailsData[0]?.RequestTitle || "";
    setDescription(requestDes);
    setRequestTitle(requestTitle);
    const employeeToEdit = employeDetails.find(
      (employee) => employee.Id === ticketDetailsData[0]?.AssignedToId
    );
    if (employeeToEdit) {
      setSelectedEmployees(employeeToEdit);
    }
    if (ticketSubcategoryTypeSelected?.length > 0) {
      const defaultSubCategory = ticketSubcategoryTypeSelected?.find(
        (Subcategory) =>
          Subcategory.Id === ticketDetailsData[0]?.RequestSubCategoryId
      );
      if (defaultSubCategory) {
        setSelectedSubCategory(defaultSubCategory.Id);
      }
    }
    if (ticketStatusType?.length > 0) {
      const statusToEdit = ticketStatusType.find(
        (status) => status.Id === ticketDetailsData[0]?.RequestStatusId
      );
      if (statusToEdit) {
        if (statusToEdit?.Id && selectedStatus) {
          setSelectedStatus(selectedStatus);
        } else {
          setSelectedStatus(statusToEdit.Id);
        }
      }
      const defaultCategory = ticketCategoryType?.find(
        (category) => category.Id === ticketDetailsData[0]?.RequestCategoryId
      );
      const defaultServerity = ticketSeverityType?.find(
        (serverity) => serverity.Id === ticketDetailsData[0]?.Severity
      );
      const defaultPriority = ticketPriorityType?.find(
        (priority) => priority.Id === ticketDetailsData[0]?.Priority
      );

      if (defaultCategory) {
        if (defaultCategory?.Id && selectedCategory) {
          setSelectedCategory(selectedCategory);
        } else {
          setSelectedCategory(defaultCategory.Id);
        }
      }
      if (defaultServerity) {
        if (defaultServerity?.Id && selectedServerity) {
          setSelectedServerity(selectedServerity);
        } else {
          setSelectedServerity(defaultServerity.Id);
        }
      }
      if (defaultPriority) {
        if (defaultPriority?.Id && selectedPriority) {
          setSelectedPriority(selectedPriority);
        } else {
          setSelectedPriority(defaultPriority.Id);
        }
      }
    }
    if (ticketHistoryDetailsData?.length > 0) {
      let lastIndex = ticketHistoryDetailsData.length - 1;
      setShowFirstDetailsOfHistory(ticketHistoryDetailsData[lastIndex]);
    }
  }, [
    ticketDetailsData,
    employeDetails,
    selectedStatus,
    ticketMasterDataList,
    ticketHistoryDetailsData,
    ticketSubcategoryTypeSelected,
  ]);

  useEffect(() => {
    if (selectedCategory) {
      let seletedSubCat = ticketSubcategoryType.filter(
        (item) => item.CategoryId === selectedCategory
      );
      setTicketSubcategoryTypeSelected(seletedSubCat);
    }
    if (ticketNotificationId) {
      getTicketData();
    }
  }, [selectedCategory, ticketNotificationId]);

  async function getMasterTicketStatus() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "TicketStatusType",
    };
    try {
      const data = await GetMasterTypeData(params);
      setTicketStatusType(data?.Data);
    } catch (error) {
      setIsloading(false);
    }
  }

  async function getMasterTicketCategory() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "Category",
    };
    try {
      const data = await GetMasterTypeData(params);
      setTicketCategoryType(data?.Data);
    } catch (error) {
      setIsloading(false);
    }
  }

  async function getMasterTicketSubCategory() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "Subcategory",
    };
    try {
      const data = await GetMasterTypeData(params);
      setTicketSubcategoryType(data?.Data);
    } catch (error) {
      setIsloading(false);
    }
  }

  async function getMasterTicketPriority() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "Priority",
    };
    try {
      const data = await GetMasterTypeData(params);
      setTicketPriorityType(data?.Data);
    } catch (error) {
      setIsloading(false);
    }
  }

  async function getMasterTicketSeverity() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "Severity",
    };
    try {
      const data = await GetMasterTypeData(params);
      setTicketSeverityType(data?.Data);
    } catch (error) {
      setIsloading(false);
    }
  }

  const determineDocType = (DocData) => {
    const imageExtensions = /\.(jpg|jpeg|png|gif|bmp)$/i;
    const pdfExtension = /\.pdf$/i;

    if (imageExtensions.test(DocData)) {
      return "image";
    } else if (pdfExtension.test(DocData)) {
      return "pdf";
    } else {
      return "Doc";
    }
  };

  return (
    <div>
      <div Id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>
        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>
      {/* <!-- row --> */}
      <div className="container-fluid position-relation">
        <div className="row">
          <div className="col-xl-12">
            <div className="row g-3">
              <div className="d-flex justify-content-end">
                <button className="btn btn-purple me-2 " type="submit">
                  Transfer/issues
                </button>
                <button className="btn btn-purple me-2" type="submit">
                  Return to stock
                </button>
                <button className="btn btn-purple me-2 " type="submit">
                  Discard
                </button>
                <button className="btn btn-purple me-2" type="submit">
                  Add Note
                </button>
                <Link to="/Assets/ListHtml">
                  <button className="back-newticket w-auto float-right">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-arrow-left-short"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                      />
                    </svg>
                    Back
                  </button>
                </Link>
              </div>
              <div className="col-xl-8">
                <div className="card">
                  <div className="card-body">
                    <img
                      src="/images/org-img/leave/popup-backimg.png"
                      className="sidefloatimg"
                    />
                    <h5 className="mb-0">Asset Serial No: 982000020614920</h5>
                    <div className="illustration-header00">
                      <div className="header-meta">
                        <h2 className="detailhead mb-3 mt-3">
                          Laptop
                          <img
                            src="/images/tickets/edit-ico.svg"
                            className="editdivinfo"
                            title="Edit"
                          />
                        </h2>
                        <ul className="basicinfomation basicinfomationlis">
                          <li>
                            <b>Date of Purchase :Oct 31, 2025</b>
                          </li>
                          <li>
                            <b>RAM :</b>
                          </li>
                          <li>
                            <b>Brand :</b>
                          </li>
                          <li>
                            <b>Processor :</b>
                          </li>
                          <li>
                            <b>Gen :</b>
                          </li>
                          <li>
                            <b> Storage :</b>
                          </li>
                          <li>
                            <b>Operating System :</b>
                          </li>
                          <li>
                            <b>Current IP :</b>
                          </li>
                          <li>
                            <span className="med-pri">High</span>
                          </li>
                          <li>
                            <span className="priority-status">P1</span>
                          </li>
                          <li>
                            <span className="status-chng">New</span>
                          </li>
                        </ul>
                        <div className="header-meta">
                          <h3 className="mb-3 mt-3">Description</h3>
                          <p>Related to Hardware &amp; Tech .</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-body">
                    <div className="history-tl-container">
                      <h5 className="mt-0">Assets Activity</h5>
                      <ul className="tl">
                        <li className="tl-item">
                          <div className="item-detail">1 week ago</div>
                          <div className="item-title">Laptop</div>
                          <ul className="basicinfomation basicinfomationlis">
                            <li>
                              <b>Date of Purchase :Oct 31, 2025</b>
                            </li>
                            <li>
                              <b>RAM :</b>
                            </li>
                            <li>
                              <b>Brand :</b>
                            </li>
                            <li>
                              <b>Processor :</b>
                            </li>
                            <li>
                              <b>Gen :</b>
                            </li>
                            <li>
                              <b> Storage :</b>
                            </li>
                            <li>
                              <b>Operating System :</b>
                            </li>
                            <li>
                              <b>Current IP :</b>
                            </li>
                            <li>
                              <span className="med-pri">High</span>
                            </li>
                            <li>
                              <span className="priority-status">P1</span>
                            </li>
                            <li>
                              <span className="status-chng">New</span>
                            </li>
                          </ul>
                          <p className="description">
                            <b>Description :</b>Related to Hardware &amp; Tech
                          </p>
                          <p className="commentdiv">
                            <b>Comment :</b>
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-4">
                <div className="card">
                  <div className="card-body">
                    <div className="ticket-createdby">
                      <h5 className="mt-0">Assigned by</h5>
                      <div className="ticket-file-attach__wrapper">
                        <div className="option-g">
                          <div className="info mb-0">
                            <div className="info__items_detail">
                              <div className="image">
                                <img
                                  src="http://devbox.bizbrolly.com:4006/Uploads/c737/PI/101\cropped_c9df_202508202430.jpg"
                                  alt="zip.png"
                                  width="100%"
                                />
                              </div>
                              <div className="div">
                                <h6>Liam Shep Thompson</h6>
                                <span>On&nbsp;Oct 31 2025</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-body">
                    <div className="ticket-createdby">
                      <h4 className="text-primary mb-3 sumh4 addprofile-action">
                        Images and Documents
                        {ticketDetailsData[0]?.IsEdit === 1 && (
                          <span>
                            <a
                              className="edit-btncss mb-2 love-icon"
                              onClick={() =>
                                document.getElementById("file-upload").click()
                              }
                              title="Add"
                            >
                              <img
                                src="/images/org-img/profile/add.png"
                                className=""
                              />
                            </a>
                          </span>
                        )}
                        <input
                          type="file"
                          id="file-upload"
                          className="form-control"
                          onChange={handleFileChange}
                          name="BannerImage"
                          style={{ display: "none" }}
                        />
                      </h4>

                      <div className="assets-image-area">
                        <div className="row g-2">
                          <div className="col-lg-3">
                            <div className="assets-img-block timeline-item on-hover-icon">
                              <img src="http://devbox.bizbrolly.com:4006/Uploads/c737/AR/0/cropped_23ed_202510135235.jpg" />
                              <div className="hover-badges-box">
                                <img
                                  
                                  src="/images/org-img/delete.png"
                                  
                                  title="Delete"
                                  
                                  
                                />

                                <img
                                 
                                  src="/images/org-img/edit.png"
                                  title="Edit"
                                  
                                />
                              </div>
                            </div>
                          </div>
                          {/* <div className="col-lg-3">
                                <div className="assets-img-block">
                                   <img src="http://devbox.bizbrolly.com:4006/Uploads/c737/AR/0/cropped_23ed_202510135235.jpg"/>
                                   <div className="edit-icon-assets">
                                      <img src="/images/org-img/delete.png" class="editdivinfo" title="Edit"></img>
                                   </div>
                                </div>
                             </div> */}
                          {/* <div className="col-lg-3">
                                <div className="assets-img-block">
                                   <img src="http://devbox.bizbrolly.com:4006/Uploads/c737/AR/0/cropped_23ed_202510135235.jpg"/>
                                   <div className="edit-icon-assets">
                                      <img src="/images/org-img/delete.png" class="editdivinfo" title="Edit"></img>
                                   </div>
                                </div>
                             </div>
                              <div className="col-lg-3">
                                <div className="assets-img-block">
                                   <img src="http://devbox.bizbrolly.com:4006/Uploads/c737/AR/0/cropped_23ed_202510135235.jpg"/>
                                   <div className="edit-icon-assets">
                                      <img src="/images/org-img/delete.png" class="editdivinfo" title="Edit"></img>
                                   </div>
                                </div>
                             </div>
                              <div className="col-lg-3">
                                <div className="assets-img-block">
                                   <img src="http://devbox.bizbrolly.com:4006/Uploads/c737/AR/0/cropped_23ed_202510135235.jpg"/>
                                   <div className="edit-icon-assets">
                                      <img src="/images/org-img/delete.png" class="editdivinfo" title="Edit"></img>
                                   </div>
                                </div>
                             </div>
                              <div className="col-lg-3">
                                <div className="assets-img-block">
                                   <img src="https://logowik.com/content/uploads/images/adobe-pdf3324.jpg"/>
                                   <div className="edit-icon-assets">
                                      <img src="/images/org-img/delete.png" class="editdivinfo" title="Edit"></img>
                                   </div>
                                </div>
                             </div> */}
                        </div>
                        {/* <div className="row">
                              <div className="col-lg-12">
                                 <div className="assets-img-block">
                                   <img src="https://logowik.com/content/uploads/images/adobe-pdf3324.jpg"/>
                                   <div className="edit-icon-assets">
                                      <img src="/images/org-img/delete.png" class="editdivinfo" title="Edit"></img>
                                   </div>
                                </div>
                              </div>
                          </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Dialog
        header="File Attachment"
        visible={showAllDocvisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!showAllDocvisible) return;
          setShowAllDocvisible(false);
        }}
      >
        <div className="card">
          <div className="card-body">
            <div className="review-step">
              <div className="ticket-file-attach__wrapper">
                {ticketDetailsData[0]?.Attachments?.map((docs, index) => {
                  let docMultiplePathTypeData = docs.DocPath.split("_");
                  return (
                    <div className="ticket-file-attach__items">
                      <div className="ticket-file-attach__items_detail">
                        <LazyImage src={docs.DocPath} alt="default.png" />

                        <div className="div">
                          <h6>{docMultiplePathTypeData[1]}</h6>
                          {/* <span>7.05 MB</span> */}
                        </div>
                      </div>
                      <div className="ticket-file-attach__items_download">
                        <a
                          href={docs.DocPath}
                          target="blank"
                          onClick={() => {
                            setDeleteTicketItemId(docs?.Id);
                            GetMasterSystemAlertList("Document_Delete", 1);
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="svg replaced-svg"
                          >
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                            <polyline points="7 10 12 15 17 10"></polyline>
                            <line x1="12" y1="15" x2="12" y2="3"></line>
                          </svg>
                        </a>
                        <a>
                          <img
                            style={{
                              marginLeft: "16px",
                              width: "20%",
                              padding: "5px",
                              cursor: "pointer",
                            }}
                            src="/images/org-img/delete.png"
                            className="side-delete"
                            title="Delete"
                            data-bs-toggle="modal"
                            onClick={() =>
                              setShowAllDelete({
                                show: true,
                                type: "Doc",
                              })
                            }
                          />
                        </a>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </Dialog>
      <div className="modal fade" Id="delete-ed">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content delete-holiday">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <div className="img">
                <img src="/images/org-img/leave/trash.png" />
              </div>
            </div>
            <div className="modal-body text-center">
              <strong className="modal-title">Are you sure?</strong>
              <p>{deleteContent}</p>
            </div>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="cancelbtn-click"
                data-bs-dismiss="modal"
                onClick={() => {
                  setShowAllDelete(false);
                  setDeleteContent([]);
                }}
              >
                Close
              </button>
              <button
                type="button"
                className="deletebtn-click"
                data-bs-dismiss="modal"
                onClick={() => deleteTicketItemData()}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      {Isloading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
}

export default AssetsDetailHtml;
